import { useState, useCallback, useEffect } from "react";
import { BACKEND } from "../../../../consts/backend";

// ─── Alert metadata ───────────────────────────────────────────────────────────

export const ALERT_META = {
  despachos_mismo_despacho: {
    label: "Despacho compartido", group: "DESPACHOS", severity: "danger",
    tooltip: "El mismo despacho esta en varias PO",
    icon: "copy", cols: ["type", "despacho", "cant_pos", "pos"],
    filterCols: {
      EXPO: ["type", "despacho", "cant_pos", "pos", "mot", "cliente"],
    },
    colLabels: { mot: "MOT", cliente: "Cliente" },
    subGroup: "despachos",
  },
  misma_po_multi_despacho: {
    label: "PO con múltiples despachos", group: "DESPACHOS", severity: "danger",
    tooltip: "PO con varios despachos asignados",
    icon: "layer", cols: ["po", "tipo_orden", "cant_despachos", "despachos"], subGroup: "despachos",
  },
  items_mismatch: {
    label: "Items orden ≠ items Despachos", group: "DESPACHOS", severity: "warning",
    tooltip: "Hay diferencias entre los items que figuran en la orden y los de su despacho asignado",
    icon: "alert-circle", cols: ["po", "despacho", "tipo_orden", "items_orden", "items_simis", "created_at"],
    filterCols: {
      IMPO: ["po", "despacho", "tipo_orden", "business", "items_orden", "items_simis", "created_at"],
      EXPO: ["po", "despacho", "tipo_orden", "items_orden", "items_simis", "created_at", "mot", "cliente"],
    },
    colLabels: { items_simis: "ITEMS DESPACHOS", business: "Business", mot: "MOT", cliente: "Cliente" },
    subGroup: "despachos",
  },
  po_sin_despacho: {
    label: "PO sin número de despacho", group: "DESPACHOS", severity: "warning",
    tooltip: "Ordenes sin Nro de Despacho asignado",
    icon: "minus-circle", cols: ["po", "tipo_orden", "estado", "ata"],
    filterCols: {
      IMPO: ["po", "tipo_orden", "estado", "business", "ata"],
      EXPO: ["po", "tipo_orden", "estado", "ata", "mot", "cliente"],
    },
    colLabels: { business: "Business", mot: "MOT", cliente: "Cliente" }, subGroup: "orders",
  },
  despacho_no_en_despachos_ni_s3: {
    label: "Sin registro Despachos o S3", group: "DESPACHOS", severity: "warning",
    tooltip: "Ordenes cuyo despacho, el pdf no esta cargado y/o la info del .ret no esta",
    icon: "files", cols: ["po", "despacho", "tipo_orden", "existe_en_simis", "existe_en_s3"],
    filterCols: {
      EXPO: ["po", "despacho", "tipo_orden", "existe_en_simis", "existe_en_s3", "mot", "cliente"],
    },
    colLabels: { existe_en_simis: "Existe en Despachos", mot: "MOT", cliente: "Cliente" }, subGroup: "despachos",
  },
  despachos_anualdos_po: {
    label: "Despachos Anulados", group: "DESPACHOS", severity: "danger",
    tooltip: "Ordenes que tienen Despachos asignados que estan anulados (detalle extraido de intersys)",
    icon: "file-remove", cols: ["type", "purchase_order", "despacho", "status", "ata"],
    filterCols: {
      EXPO: ["type", "purchase_order", "despacho", "status", "ata", "mot", "cliente"],
    },
    colLabels: { type: "Tipo", purchase_order: "PO", status: "Estado", ata: "ATA", mot: "MOT", cliente: "Cliente" },
    subGroup: "despachos",
  },
  po_canceladas_con_despachos: {
    label: "PO Cancelada con Despacho", group: "EXPO", severity: "danger",
    tooltip: "PO en status Cancelada con Despacho Cargado",
    icon: "alert-circle", cols: ["type", "purchase_order", "despacho", "status", "ata", "mot", "cliente"],
    colLabels: { type: "Tipo", purchase_order: "PO", status: "Estado", ata: "ATA", mot: "MOT", cliente: "Cliente" },
    subGroup: "orders",
  },
  mro_oficializada_sin_docs: {
    label: "Oficializada sin documentación", group: "MRO", severity: "danger",
    tooltip: "Ordenes Oficializadas sin docs cargados",
    icon: "file-remove", cols: ["Orden", "oficializacion"], subGroup: "orders",
  },
  expo_sin_permition_date: {
    label: "Sin fecha de oficialización", group: "EXPO", severity: "warning",
    tooltip: "Ordenes sin fecha de Oficializacion Cargada",
    icon: "calendar", cols: ["po", "despacho", "estado"], subGroup: "orders",
  },
  expo_file_repetido: {
    label: "File Repetido", group: "EXPO", severity: "info",
    tooltip: "Ordenes cuyo Numero de File esta Repetido",
    icon: "copy", cols: ["numero_file", "cant_pos", "pos"], subGroup: "orders",
  },
  expo_transit_fechas: {
    label: "In Transit — fechas incompletas", group: "EXPO", severity: "warning",
    tooltip: "Orden In Transit con fechas incompletas que deberia tener",
    icon: "clock", cols: ["purchase_order", "eta", "atd"], subGroup: "orders",
  },
  expo_arrived_fechas: {
    label: "Arrived — fechas incompletas", group: "EXPO", severity: "warning",
    tooltip: "Orden Arrived con fechas incompletas que deberia tener",
    icon: "clock", cols: ["purchase_order", "eta", "etd", "atd", "ata"], subGroup: "orders",
  },
  impo_fechas_por_estado: {
    label: "Datos faltantes por estado", group: "IMPO", severity: "warning",
    tooltip: "Datos Faltantes por estado",
    icon: "clock", cols: ["po", "estado", "business", "campos_faltantes"],
    colLabels: { business: "Business" }, subGroup: "orders",
  },
  impo_fecha_estimada_vencida: {
    label: "Fecha estimada vencida", group: "IMPO", severity: "danger",
    tooltip: "PO con fechas estimadas vencidas sin actuales",
    icon: "alarm-alt", cols: ["po", "estado", "business", "alertas_fecha", "etd", "atd", "eta", "ata"],
    colLabels: { business: "Business" }, subGroup: "orders",
  },
  impo_arrived_docs: {
    label: "Arrived — docs faltantes", group: "IMPO", severity: "danger",
    tooltip: "PO Arribada con docs faltantes",
    icon: "file-remove", cols: ["po", "despacho", "pais_origen", "business", "docs_faltantes", "ata"],
    colLabels: { business: "Business" }, subGroup: "orders",
  },
  impo_canal: {
    label: "PO Sin canal Asignado", group: "IMPO", severity: "warning",
    tooltip: "PO sin Canal asignado",
    icon: "signal", cols: ["po", "despacho", "estado", "business", "canal", "destiantion_type"],
    colLabels: { destiantion_type: "Destination Type", business: "Business" }, subGroup: "orders",
  },
  impo_po_oficializada_sin_liberar: {
    label: "PO Oficializada sin Liberar", group: "IMPO", severity: "danger",
    tooltip: "PO Oficializada sin fecha Released cargada",
    icon: "lock-alt", cols: ["po", "despacho", "estado", "business", "fecha_oficializacion", "ata"],
    colLabels: { fecha_oficializacion: "Fecha Oficialización", business: "Business" }, subGroup: "orders",
  },
  impo_po_nodata_cargoes: {
    label: "PO Trackeada con Issues", group: "IMPO", severity: "danger",
    tooltip: "PO trackeada con algun Issue",
    icon: "alert-circle", cols: ["po", "mbl", "estado", "business", "estado_cargoes", "segments_faltantes", "fecha_creacion_cargoes", "ultima_fecha_actualizacion_cargoes", "datos_faltantes"],
    colLabels: {
      business: "Business",
      mbl: "MBL",
      estado_cargoes: "Est. Cargoes",
      segments_faltantes: "Seg. Faltantes",
      fecha_creacion_cargoes: "F. Crea. Cargoes",
      ultima_fecha_actualizacion_cargoes: "U. Act. Cargoes",
    },
    subGroup: "orders",
  },
};

export const GROUP_ORDER = ["DESPACHOS", "MRO", "EXPO", "IMPO"];

export const GROUP_CONFIG = {
  DESPACHOS: { color: "#798bff", bg: "rgba(121,139,255,.12)", icon: "package", label: "Despachos" },
  MRO:       { color: "#09c2de", bg: "rgba(9,194,222,.12)",   icon: "box",     label: "MRO" },
  EXPO:      { color: "#1ee0ac", bg: "rgba(30,224,172,.12)",  icon: "upload",  label: "EXPO" },
  IMPO:      { color: "#1565c0", bg: "rgba(21,101,192,.12)",  icon: "download", label: "IMPO" },
};

// ─── Endpoints ────────────────────────────────────────────────────────────────

export const ALERT_ENDPOINTS = {
  despachos_mismo_despacho:        "/api/alertas/despachos_mismo_despacho",
  misma_po_multi_despacho:         "/api/alertas/misma_po_multi_despacho",
  items_mismatch:                  "/api/alertas/items_mismatch",
  po_sin_despacho:                 "/api/alertas/po_sin_despacho",
  despacho_no_en_despachos_ni_s3:  "/api/alertas/despacho_no_en_despachos_ni_s3",
  despachos_anualdos_po:           "/api/alertas/despachos_anualdos_po",
  po_canceladas_con_despachos:     "/api/alertas/po_canceladas_con_despachos",
  mro_oficializada_sin_docs:       "/api/alertas/mro_oficializada_sin_docs",
  expo_sin_permition_date:         "/api/alertas/expo_sin_permition_date",
  expo_file_repetido:              "/api/alertas/expo_file_repetido",
  expo_transit_fechas:             "/api/alertas/expo_transit_fechas",
  expo_arrived_fechas:             "/api/alertas/expo_arrived_fechas",
  impo_fechas_por_estado:                  "/api/alertas/impo_fechas_por_estado",
  impo_fecha_estimada_vencida:             "/api/alertas/impo_fecha_estimada_vencida",
  impo_arrived_docs:                       "/api/alertas/impo_arrived_docs",
  impo_canal:                              "/api/alertas/impo_canal",
  impo_po_oficializada_sin_liberar:        "/api/alertas/impo_po_oficializada_sin_liberar",
  impo_po_nodata_cargoes:        "/api/alertas/alertas_impo_po_nodata_cargoes",
};

export const GROUP_ALERT_KEYS = {
  DESPACHOS: [
    "despachos_mismo_despacho",
    "misma_po_multi_despacho",
    "items_mismatch",
    "po_sin_despacho",
    "despacho_no_en_despachos_ni_s3",
    "despachos_anualdos_po",
  ],
  MRO:       ["mro_oficializada_sin_docs"],
  EXPO:      [
    "expo_sin_permition_date",
    "expo_file_repetido",
    "expo_transit_fechas",
    "expo_arrived_fechas",
    "po_canceladas_con_despachos",
  ],
  IMPO:      ["impo_fechas_por_estado", "impo_fecha_estimada_vencida", "impo_arrived_docs", "impo_canal", "impo_po_oficializada_sin_liberar", "impo_po_nodata_cargoes"],
};

// ─── Filter helper ────────────────────────────────────────────────────────────

export const filterDespachosByType = (rows, type) => {
  if (!Array.isArray(rows)) return [];
  return rows.filter((r) => {
    const t = (r.tipo_orden || r.type || "").toString().toUpperCase();
    if (type === "IMPO") return t === "I" || t === "IMPO";
    if (type === "EXPO") return t === "E" || t === "EXPO";
    return true;
  });
};

// ─── Role helpers ─────────────────────────────────────────────────────────────

const TYPE_TABS = ["IMPO", "EXPO", "MRO"];

export const getVisibleGroups = (userRole) => {
  if (["import", "import admin"].includes(userRole)) return ["DESPACHOS", "IMPO"];
  if (["export", "export admin"].includes(userRole)) return ["DESPACHOS", "EXPO"];
  if (["mro", "mro admin"].includes(userRole))       return ["MRO"];
  return GROUP_ORDER;
};

export const getAllowedTypeTabs = (userRole) => {
  if (["import", "import admin"].includes(userRole)) return ["IMPO"];
  if (["export", "export admin"].includes(userRole)) return ["EXPO"];
  if (["mro", "mro admin"].includes(userRole))       return ["MRO"];
  return TYPE_TABS;
};

export const getDespachoOt = (userRole) => {
  if (["import", "import admin"].includes(userRole)) return "I";
  if (["export", "export admin"].includes(userRole)) return "E";
  return null;
};

// ─── useAlertsFetch hook ──────────────────────────────────────────────────────

export const useAlertsFetch = (userRole) => {
  const [alerts, setAlerts] = useState({});
  const [loadingGroups, setLoadingGroups] = useState({});
  const [errorGroups, setErrorGroups] = useState({});

  const visibleGroups = getVisibleGroups(userRole);
  const despachoOt = getDespachoOt(userRole);

  const fetchAlerts = useCallback(async () => {
    const base = (BACKEND || "").replace(/\/$/, "");
    setAlerts({});
    setErrorGroups({});

    const initLoading = {};
    visibleGroups.forEach((g) => { initLoading[g] = true; });
    setLoadingGroups(initLoading);

    await Promise.all(
      visibleGroups.map(async (group) => {
        const keys = GROUP_ALERT_KEYS[group];
        try {
          const results = await Promise.all(
            keys.map(async (key) => {
              let url = `${base}${ALERT_ENDPOINTS[key]}`;
              if (group === "DESPACHOS" && despachoOt) {
                url += `?order_type=${despachoOt}`;
              }
              const res = await fetch(url);
              if (!res.ok) throw new Error(`HTTP ${res.status} (${key})`);
              const json = await res.json();
              const rows = Array.isArray(json.alerts) ? json.alerts : [];
              return { key, rows };
            })
          );
          setAlerts((prev) => {
            const next = { ...prev };
            results.forEach(({ key, rows }) => { next[key] = rows; });
            return next;
          });
        } catch (e) {
          setErrorGroups((prev) => ({ ...prev, [group]: e.message || "Error" }));
        } finally {
          setLoadingGroups((prev) => ({ ...prev, [group]: false }));
        }
      })
    );
  }, [userRole]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { fetchAlerts(); }, [fetchAlerts]);

  return { alerts, loadingGroups, errorGroups, fetchAlerts };
};
